module.exports = __webpack_public_path__ + "img/8.9acd0758.jpg";